module.exports = __webpack_public_path__ + "media/Video 13.05eb5327.mp4";